import { render } from "./LoadingUpdater.vue?vue&type=template&id=63bf3e52"
import script from "./LoadingUpdater.vue?vue&type=script&lang=js"
export * from "./LoadingUpdater.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__